import { createReducer, on } from "@ngrx/store";

import { RegistrationWithCepAction } from "./registration-with-cep.action";
import { RegistrationWithCepState } from "./registration-with-cep.model";

const INITIAL_STATE: RegistrationWithCepState = {
	success: false,
	address: undefined,
	error: undefined,
	isBusy: false,
};

export const registrationWithCepReducer = createReducer(
	INITIAL_STATE,
	on(RegistrationWithCepAction.getAddressByCep, (state) => ({
		...state,
		isBusy: true,
		address: undefined,
		error: undefined,
		success: false,
	})),
	on(RegistrationWithCepAction.getAddressByCepSuccess, (state, { response }) => ({
		...state,
		isBusy: false,
		address: response,
		error: undefined,
		success: true,
	})),
	on(RegistrationWithCepAction.getAddressByCepFail, (state, { error }) => ({
		...state,
		isBusy: false,
		address: undefined,
		error,
		success: false,
	})),
	on(RegistrationWithCepAction.cepValueCheckFail, (state) => ({
		...state,
		success: false,
	}))
);
